
import React, { useContext, useEffect, useReducer, useState } from "react";
import { styled } from "styled-components";
import { httpRequest, httpRequest1, httpRequest2 } from "../utils/httpsRequest";
import { AppLoader } from "./LoaderSpinner";
import { SearchForm } from "./Form";
import { PrimaryButton } from "./Buttons";
import Table from "./Table2";
import { Pagination } from "./Pagination";
import Card2 from "./Card";
import Modal from "./Modal";
import OpCodeCreateForm from "./OpCodeCreateForm";
import OpCodeBulkCreateForm from "./OpCodeBulkCreateForm";
import { UserStoryContext } from "../context/UserStoryState";
import { apiConfig } from "../utils/api/config";
import { performApiRequest } from "../utils/apiRequest";
import DownloadCSV from './DownloadCSV';
import { Button } from "./ui/button";
import { Input } from "./ui/input"
import OpCodeTable from "./Table2";
import OpCodeTableMultiple from "./OpCodeTableMultiple";
import { Filter } from 'lucide-react'
import {
    CollapsibleTrigger,
    CollapsibleContent,
    Collapsible,
} from "./ui/collapsible";

const SearchToggleContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 10px 0;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: #faf9f450;
    padding: 10px;
    border-radius: 15px;
`;

const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0 20px 0;
    width: 100%;
`;

const CreateSearchContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0 20px 0;
    width: 100%;
`;

const initialSearchState = {
    template: {
        templateName: "",
        tableName: "",
        searchComponent: {},
        tableComponent: {},
        OpCodeEditTemplateName: "",
    },
    formData: {},
    currentPage: 1,
    tableData: {},
    totalPage: 0,
    totalFetchedRow: 0,
    totalRows: 0,
    prevFrameData: {},
};

const searchReducer = (state, action) => {
    console.log("action", action);
    switch (action.type) {
        case "SET_TEMPLATE":
            return { ...state, template: action.payload };
        case "SET_FORM_DATA":
            return { ...state, formData: action.payload };
        case "SET_TABLE_DATA":
            return { ...state, tableData: action.payload };
        case "SET_CURRENT_PAGE":
            return { ...state, currentPage: action.payload };
        case "SET_TOTAL_PAGE":
            return { ...state, totalPage: action.payload };
        case "SET_FETCHED_TOTAL_ROW":
            return { ...state, totalFetchedRow: action.payload };
        case "SET_TOTAL_ROWS":
            return { ...state, totalRows: action.payload };
        case "SET_PREVIOUS_CONTEXT_DATA":
            return { ...state, prevFrameData: action.payload };
        default:
            return state;
    }
};
function createNewDictWithKeys(originalDict, keys) {
    return keys.reduce((newDict, key) => {
        if (key in originalDict) {
            if (key.endsWith('_recid')) {
                newDict[key.slice(0, -'_recid'.length)] = originalDict[key];  // Remove '_recid' from the key
            } else {
                newDict[key] = originalDict[key];  // Keep the key as it is
            }
        }
        return newDict;
    }, {});
}
// const transformData = (inputData) => {
//     // Use Object.values to get an array of nhe nested objects
//     const valuesArray = Object.values(inputData);

//     // Reduce the array to a single object
//     const transformedData = valuesArray.reduce((acc, curr) => {
//         // Merge the current object into the accumulator
//         return { ...acc, ...curr };
//     }, {});

//     return transformedData;
// };
const transformData = (inputData) => {
    // If inputData is null, treat it as an empty object
    if (inputData === null) {
        inputData = {};
    }

    // Use Object.values to get an array of the nested objects
    const valuesArray = Object.values(inputData);

    // Reduce the array to a single object
    const transformedData = valuesArray.reduce((acc, curr) => {
        // Merge the current object into the accumulator
        return { ...acc, ...curr };
    }, {});

    return transformedData;
};

export default function OpCodeSearchForm({
    templateName,
    prevFrame = null,
    isUserStory = false,
    needCreate = false,
    isBulkCreate = false,
    filter = null,
    createModalTemplate = null,
    apiCalls,
    contextField = false,
    data = false,
    allFrameData = false,
    setAllFrameData = false,
    exportcsv = false,
    edit = false,
    displayDetailsbtn = false,
    isItMultiSelect = false

}) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [hoverSearch, setHoverSearch] = useState(false);
    const [hoverClear, setHoverClear] = useState(false);

    const [state, dispatch] = useReducer(searchReducer, initialSearchState);
    const {
        template,
        formData,
        tableData,
        currentPage,
        totalPage,
        totalFetchedRow,
        totalRows,
        prevFrameData,
    } = state;

    const [showSearchForm, setShowSearchForm] = useState(false);
    const [isFetching, setIsFetching] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const { GetPreviousContextData } = useContext(UserStoryContext);
    useEffect(() => {
        const getTemplate = async () => {
            if (prevFrame !== null && isUserStory === true) {
                console.log("pre contest", transformData(GetPreviousContextData()))
                const prevFrameDataTemp = transformData(GetPreviousContextData());
                if (prevFrameDataTemp !== null) {
                    dispatch({
                        type: "SET_FORM_DATA",
                        payload: prevFrameDataTemp,
                    });
                    dispatch({
                        type: "SET_PREVIOUS_CONTEXT_DATA",
                        payload: prevFrameDataTemp,
                    });
                }
            }

            let previousResponse = null
            let totalRowsPerPage = null
            let tableDisplayOrder = null

            if (apiCalls && apiCalls.length !== 0) {
                for (const { key, onLoad, onButton, server, param = null } of apiCalls) {
                    if (onLoad && onLoad === true) {
                        const config2 = apiConfig[key]
                        console.log("Configs ", config2)
                        let payload = {}
                        if (key === 'templateJson') {
                            previousResponse = await performApiRequest(
                                server,
                                key,
                                config2.url(templateName),
                                config2.method
                            );
                            previousResponse.data = previousResponse.data.templateData
                            if (previousResponse.data.length !== 0) {

                                dispatch({
                                    type: "SET_TEMPLATE",
                                    payload: previousResponse.data,
                                });
                                totalRowsPerPage =
                                    previousResponse.data.tableComponent.maxRowsPerPage;
                                tableDisplayOrder =
                                    previousResponse.data.tableComponent.resultDisplayOrder;
                            }
                        }
                        else {
                            let fdata
                            if (transformData(GetPreviousContextData()) && filter) {

                                fdata = createNewDictWithKeys(transformData(GetPreviousContextData()), filter);
                                console.log("debug1", fdata, transformData(GetPreviousContextData()), filter)
                            } else {
                                fdata = formData;
                                console.log("debug2", fdata)
                            }

                            const payLoad = config2.payloadFields(previousResponse.data, fdata, 1);
                            console.log("Search Payload", payLoad)
                            previousResponse = await performApiRequest(
                                server,
                                key,
                                config2.url,
                                config2.method,
                                payLoad,
                                null, null, null, null, null,
                                param
                            );

                            if (previousResponse.data.length !== 0) {
                                dispatch({
                                    type: "SET_TABLE_DATA",
                                    payload: previousResponse.data,
                                });
                                dispatch({
                                    type: "SET_TOTAL_PAGE",
                                    payload: Math.ceil(
                                        parseInt(
                                            previousResponse.data.totalRecords,
                                        ) / totalRowsPerPage,
                                    ),
                                });
                                if (tableDisplayOrder === "row") {
                                    dispatch({
                                        type: "SET_FETCHED_TOTAL_ROW",
                                        payload:
                                            previousResponse.data.tableRow
                                                .length,
                                    });
                                } else {
                                    dispatch({
                                        type: "SET_FETCHED_TOTAL_ROW",
                                        payload:
                                            previousResponse.data.tableCol[
                                                "recordId"
                                            ].length,
                                    });
                                }
                                dispatch({
                                    type: "SET_TOTAL_ROWS",
                                    payload: Math.ceil(
                                        parseInt(
                                            previousResponse.data.totalRecords,
                                        ),
                                    ),
                                });

                            } else {
                                dispatch({
                                    type: "SET_TABLE_DATA",
                                    payload: [],
                                });
                                dispatch({
                                    type: "SET_TOTAL_PAGE",
                                    payload: 0,
                                });
                                dispatch({
                                    type: "SET_FETCHED_TOTAL_ROW",
                                    payload: 0,
                                });
                                dispatch({
                                    type: "SET_TOTAL_ROWS",
                                    payload: 0,
                                });
                            }
                        }
                    }
                }
            }
            isFetching && setIsFetching(false);
        };

        getTemplate();

    }, [templateName]);

    function deepMerge(obj1, obj2) {
        // Create a new object to avoid mutating the original objects
        const result = { ...obj1 };

        for (let key in obj2) {
            // Check if the key exists in both objects and if the value is an object
            if (obj2.hasOwnProperty(key)) {
                if (typeof obj2[key] === "object" && obj2[key] !== null && !Array.isArray(obj2[key])) {
                    // If the key exists in both objects and is an object, merge them
                    result[key] = deepMerge(result[key] || {}, obj2[key]);
                } else {
                    // Otherwise, just assign the value from obj2 to the result
                    result[key] = obj2[key];
                }
            }
        }

        return result;
    }
    const search = async (page, clear = false, fdata = {}) => {
        console.log("pagedata fdata search2", fdata)
        let payLoad = {};
        let previousResponse = null
        if (apiCalls && apiCalls.length !== 0) {

            for (const { key, onLoad, onButton, server } of apiCalls) {
                if (onButton && onButton === true) {

                    const config2 = apiConfig[key]
                    console.log("pageformData", formData)
                    if (Object.keys(formData).length === 0 || clear === true) {
                        payLoad = config2.payloadFields(
                            template,
                            fdata,
                            (page - 1) * template.tableComponent.maxRowsPerPage,
                        );
                    } else {
                        payLoad = config2.payloadFields(
                            template,
                            fdata,
                            // formData,
                            // (page - 1) * template.tableComponent.maxRowsPerPage,
                            page
                        );


                    }
                    previousResponse = await performApiRequest(
                        server,
                        key,
                        config2.url,
                        config2.method,
                        payLoad
                    );
                    if (!previousResponse.data.error) {
                        dispatch({
                            type: "SET_TABLE_DATA",
                            payload: previousResponse.data,
                        });
                        dispatch({
                            type: "SET_TOTAL_PAGE",
                            payload: Math.ceil(
                                parseInt(previousResponse.data.totalRecords) /
                                template.tableComponent.maxRowsPerPage,
                            ),
                        });
                        if (
                            template.tableComponent.resultDisplayOrder === "row"
                        ) {
                            dispatch({
                                type: "SET_FETCHED_TOTAL_ROW",
                                payload: previousResponse.data.tableRow.length,
                            });
                        } else {
                            dispatch({
                                type: "SET_FETCHED_TOTAL_ROW",
                                payload:
                                    previousResponse.data.tableCol["recordId"].length,
                            });
                        }
                        dispatch({
                            type: "SET_TOTAL_ROWS",
                            payload: Math.ceil(
                                parseInt(previousResponse.data.totalRecords),
                            ),
                        });
                        setIsFetching(false);
                    } else {
                        dispatch({
                            type: "SET_TABLE_DATA",
                            payload: [],
                        });
                        dispatch({
                            type: "SET_TOTAL_PAGE",
                            payload: 0,
                        });
                        dispatch({
                            type: "SET_FETCHED_TOTAL_ROW",
                            payload: 0,
                        });
                        dispatch({
                            type: "SET_TOTAL_ROWS",
                            payload: 0,
                        });
                    }

                }
            }
            setIsFetching(false);
        }
        setIsFetching(false);
    };

    const handleSubmit = async () => {
        dispatch({ type: "SET_CURRENT_PAGE", payload: 1 });
        // await search(1);

        let fdata;
        if (transformData(GetPreviousContextData()) && filter) {

            fdata = createNewDictWithKeys(transformData(GetPreviousContextData()), filter);
            fdata = deepMerge(fdata, formData)
            console.log('pppp', fdata)
        } else {
            fdata = formData;
        }

        await search(1, false, fdata);

    };

    const handleClear = async () => {
        dispatch({ type: "SET_CURRENT_PAGE", payload: 1 });
        dispatch({ type: "SET_FORM_DATA", payload: {} });
        if (prevFrame !== null && isUserStory === true) {
            dispatch({
                type: "SET_FORM_DATA",
                payload: prevFrameData,
            });
        }
        let fdata;
        if (transformData(GetPreviousContextData()) && filter) {

            fdata = createNewDictWithKeys(transformData(GetPreviousContextData()), filter);

        } else {
            fdata = {};
        }

        await search(1, true, fdata);
    };

    return template.tableName !== "" ? (
        <div>
            <div className="bg-white dark:bg-gray-950 rounded-lg shadow-sm">
                <div className="px-6 py-7">
                    <Collapsible className="transition-all duration-300 ease-in-out mr-[-20]">
                        <div >
                            <CollapsibleTrigger asChild>
                                {/* <Button
                                    className="w-15"
                                    variant="outline"
                                >
                                    <FilterIcon className="w-4 h-4 mr-2" />
                                    Filters
                                </Button> */}
                                <Button
                                    variant="outline"
                                    className="
        flex items-center  px-4 py-2 text-sm font-medium 
        text-grey-800 bg-gradient-to-r from-grey-200 to-white
        border border-grey-300 rounded-lg shadow-md
        hover:from-grey-300 hover:to-grey-100
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-grey-500
        transition-all duration-200 ease-in-out
        transform hover:scale-105
      "
                                >
                                    <Filter className="w-4 h-4 mr-2" />
                                    <span className="font-semibold">Filters</span>
                                </Button>
                            </CollapsibleTrigger>
                            <CollapsibleContent className="w-full">


                                {template &&
                                    template.searchComponent &&
                                    template.searchComponent.fields &&
                                    template.searchComponent.fields.length > 0 && (
                                        <div className="flex flex-col items-center space-y-4">
                                            <div className="grid grid-cols-1 sm:grid-cols-1 gap-4 w-100">
                                                <div className="flex justify-center space-x-4 ">
                                                    <SearchForm
                                                        formData={formData}
                                                        fields={template.searchComponent.fields}
                                                        windowWidth={windowWidth}
                                                        dispatch={dispatch}

                                                    />



                                                </div>
                                                <div className="flex justify-center space-x-4 ">

                                                    <PrimaryButton
                                                        onClick={() => {
                                                            handleSubmit();
                                                            setIsFetching(true);
                                                        }}
                                                        $text="Search"
                                                        disabled={false}
                                                        style={{
                                                            backgroundColor: hoverSearch ? "#2d6a4f" : "#38a169",
                                                            color: "white",
                                                        }}
                                                        onMouseEnter={() => setHoverSearch(true)}
                                                        onMouseLeave={() => setHoverSearch(false)}

                                                    />
                                                    <PrimaryButton
                                                        $text="Clear Filter"
                                                        onClick={() => {
                                                            handleClear();
                                                            setIsFetching(true);
                                                        }}
                                                        disabled={false}
                                                        // variant="destructive"
                                                        variant="outline"
                                                        style={{
                                                            color: "#b1092a",
                                                            backgroundColor: hoverClear ? "#fee2e2" : "transparent",
                                                        }}
                                                        onMouseEnter={() => setHoverClear(true)}
                                                        onMouseLeave={() => setHoverClear(false)}

                                                    />
                                                </div>

                                            </div>
                                        </div>
                                    )}
                            </CollapsibleContent>

                        </div>
                    </Collapsible>
                    {needCreate && (
                        <div className="flex justify-end p-4" Style="
    margin-top: -6%;
" >
                            <Button onClick={() => setShowModal((prev) => !prev)} style={{ borderRadius: "5px", width: "200px", marginLeft: "10px" }}>
                                <PlusIcon className="mr-2 h-4 w-4" />
                                Create
                            </Button>
                        </div>
                    )}

                </div>
            </div >
            <div>
                {needCreate && !createModalTemplate && (
                    <CreateSearchContainer>
                        {showModal && (
                            <Modal
                                $isOpen={showModal}
                                setOpenModal={setShowModal}>
                                <Modal.Header>
                                    Create Form - {templateName}
                                </Modal.Header>
                                <Modal.Body>
                                    {isBulkCreate === false ? (
                                        <OpCodeCreateForm
                                            templateName={templateName}
                                        />
                                    ) : (
                                        <OpCodeBulkCreateForm
                                            templateName={templateName}
                                        />
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "end",
                                        }}
                                    >
                                        <PrimaryButton
                                            $text="Close"
                                            onClick={() => {
                                                setShowModal(false);
                                            }}
                                            style={{ backgroundColor: "black" }}
                                        />
                                    </div>
                                </Modal.Footer>
                            </Modal>
                        )}
                    </CreateSearchContainer>
                )}
            </div>

            {needCreate && createModalTemplate && (
                <Modal
                    $isOpen={showModal}
                    setOpenModal={setShowModal}>
                    <Modal.Header>OP Code Create Form</Modal.Header>
                    <Modal.Body>
                        <OpCodeCreateForm
                            templateName={createModalTemplate.frameTemplateName}
                            prevFrame={createModalTemplate.previousFrame}
                            isUserStory={true}
                            filter={createModalTemplate.filter}
                            apiCalls={createModalTemplate.apiCalls}
                        />
                    </Modal.Body>
                </Modal>
            )}
            <div>


            </div>

            <div className="">
                {tableData && (
                    <Card2
                        body={

                            isItMultiSelect ? (
                                <OpCodeTableMultiple
                                    isFetching={isFetching}
                                    templateName={templateName}
                                    OpCodeEditTemplateName={template.OpCodeEditTemplateName}
                                    tableName={template.tableName}
                                    tableCol={template.tableComponent.tableCol}
                                    tableData={tableData}
                                    totalFetchedRow={totalFetchedRow}
                                    haveSelect={!!isUserStory}
                                    dispatch={dispatch}
                                    tableDisplayOrder={template.tableComponent.resultDisplayOrder}
                                    contextField={contextField}
                                    data={data}
                                    allFrameData={allFrameData}
                                    setAllFrameData={setAllFrameData}
                                    edit={edit}
                                    details={template.viewDetailComponent}
                                    displayDetailsbtn={displayDetailsbtn}
                                />
                            ) : (
                                <OpCodeTable
                                    isFetching={isFetching}
                                    templateName={templateName}
                                    OpCodeEditTemplateName={template.OpCodeEditTemplateName}
                                    tableName={template.tableName}
                                    tableCol={template.tableComponent.tableCol}
                                    tableData={tableData}
                                    totalFetchedRow={totalFetchedRow}
                                    haveSelect={!!isUserStory}
                                    dispatch={dispatch}
                                    tableDisplayOrder={template.tableComponent.resultDisplayOrder}
                                    contextField={contextField}
                                    data={data}
                                    allFrameData={allFrameData}
                                    setAllFrameData={setAllFrameData}
                                    edit={edit}
                                    details={template.viewDetailComponent}
                                    displayDetailsbtn={displayDetailsbtn}
                                />
                            )
                        }
                        footer={[
                            tableData && totalFetchedRow > 0 && (
                                <PaginationContainer>
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPage}
                                        totalRows={totalRows}
                                        maxNumberOfRows={
                                            template.tableComponent
                                                .maxRowsPerPage
                                        }
                                        totalFetchedRow={totalFetchedRow}
                                        onPageChange={(page) => {
                                            dispatch({
                                                type: "SET_CURRENT_PAGE",
                                                payload: page,
                                            });
                                            search(page);
                                        }}
                                        setFetching={setIsFetching}
                                    />
                                </PaginationContainer>
                            ),
                        ]}
                        footerCenter={false}

                    />

                )}
                {exportcsv && (

                    <div className="flex items-center space-x-4">
                        <DownloadCSV jsonData={tableData.tableRow} fileName="data.csv" />
                    </div>)}
            </div>
            {/* {
            showModal &&
            <Modal open={showModal} title='OpCode Create' onClose={() => setShowModal((prev) => !prev)}>
              {
                template.formComponent?.isBulk === true? 
                  <OpCodeBulkCreate templateName={templateName} className="app" />
                :
                  <OpCodeCreate templateName={templateName} className="app" />
              }
            </Modal>
          } */}
        </div >
    ) : (
        <div>
            <div style={{ height: '300px', width: '100%', background: '#f0f0f0' }}>
                {/* AppLoader will be centered within this div */}
                <AppLoader size={40} color="text-black-500" />
            </div>
        </div>
    );
}

function FilterIcon(props) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
    );
}

function PlusIcon(props) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    );
}